(() => {
  const root = document.querySelector("[data-personaliser]");
  if (!root) return;
  const productHandle = window.location.pathname
    .split("/")
    .filter(Boolean)
    .pop();
  const design = productHandle.replace(/-(christmas-card|mug|t-shirt)$/, "");
  const enabledDesigns = [
    "all-i-want",
    "driving-home",
    "mommy-kissing-santa",
    "george-michael-christmas-heart",
    "let-it-snow",
    "santa-baby",
  ];
  const configuredDesign = root.dataset.design;
  const designValid =
    enabledDesigns.includes(design) &&
    (!configuredDesign || configuredDesign === design);
  root.dataset.design = design;
  const q = (s) => root.querySelector(s),
    api = root.dataset.api,
    form = root.closest("form"),
    buy = form.querySelector('button[type="submit"]'),
    variantSelect = form.querySelector('[name="id"]'),
    originalVariant = [...variantSelect.options].find(
      (o) => o.dataset.design === "Original artwork",
    ),
    customVariant = [...variantSelect.options].find(
      (o) => o.dataset.design === "Custom artwork",
    ),
    media = document.querySelector(".product-media .merch-body img"),
    original = media.getAttribute("src"),
    originalAlt = media.alt,
    file = q('input[type="file"]'),
    consent = q("[data-consent]"),
    generate = q("[data-generate]"),
    key = "eightiesxmas-personalisation-v4-" + root.dataset.design;
  let state = {},
    busy = !1,
    polling = !1,
    previewUrl = "",
    sourceUrl = "",
    epoch = 0;
  const custom = () => q('[value="custom"]').checked,
    say = (text, error = !1) => {
      ((q("[data-status]").textContent = text),
        q("[data-status]").classList.toggle("is-error", error));
    };
  function verifyDesign(result) {
    if (result.template_id !== design) {
      state = {};
      clearStorage();
      previewUrl = "";
      throw new Error(
        "This preview belongs to a different design. Please create a new preview.",
      );
    }
    return result;
  }
  const approved = () =>
    designValid && state.status === "approved" && state.template_id === design;
  function save() {
    try {
      sessionStorage.setItem(key, JSON.stringify(state));
    } catch {}
  }
  function clearStorage() {
    try {
      sessionStorage.removeItem(key);
    } catch {}
  }
  function sync() {
    q("[data-custom-panel]").hidden = !custom();
    const ready = ["awaiting_approval", "approved"].includes(state.status);
    ((q("[data-upload-fields]").hidden = ready),
      (q("[data-change]").hidden = !ready));
    const variant = custom() ? customVariant : originalVariant;
    (variant &&
      variantSelect.value !== variant.value &&
      ((variantSelect.value = variant.value),
      variantSelect.dispatchEvent(new Event("change", { bubbles: !0 }))),
      (buy.disabled =
        !variant || variant.disabled || (custom() && !approved())),
      (generate.disabled =
        !designValid || busy || !file.files.length || !consent.checked),
      (file.disabled = busy),
      (consent.disabled = busy),
      (q("[data-review]").hidden =
        !previewUrl || state.status !== "awaiting_approval"),
      (q("[data-approved]").hidden = state.status !== "approved"),
      (q('[data-property="label"]').value =
        "Custom face \u2014 preview approved"),
      (q('[data-property="id"]').value = state.id || ""),
      (q('[data-property="artwork"]').value = state.artwork_url || ""),
      root
        .querySelectorAll("[data-property]")
        .forEach((el) => (el.disabled = !custom() || !approved())),
      (media.src = custom() && previewUrl ? previewUrl : original),
      (media.alt =
        custom() && previewUrl
          ? "Your personalised artwork preview"
          : originalAlt),
      (q("[data-full-preview]").src = previewUrl || original));
  }
  async function request(path, options = {}) {
    const headers = new Headers(options.headers);
    state.token && headers.set("Authorization", "Bearer " + state.token);
    const response = await fetch(api + path, {
      ...options,
      headers,
      signal: AbortSignal.timeout(3e4),
    });
    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      throw (
        response.status === 401 && ((state = {}), clearStorage()),
        new Error(
          typeof data.detail == "string"
            ? data.detail
            : "We could not complete that request. Please try again.",
        )
      );
    }
    return response;
  }
  async function image() {
    const response = await request("/storefront/jobs/" + state.id + "/image");
    (previewUrl.startsWith("blob:") && URL.revokeObjectURL(previewUrl),
      (previewUrl = URL.createObjectURL(await response.blob())));
  }
  async function poll() {
    if (polling) return;
    ((polling = !0), (busy = !0), sync(), (q("[data-check]").hidden = !0));
    const current = epoch;
    try {
      for (let n = 0; n < 100; n++) {
        const result = await (
          await request("/storefront/jobs/" + state.id)
        ).json();
        if (current !== epoch) return;
        if (
          (Object.assign(state, verifyDesign(result)),
          save(),
          ["awaiting_approval", "approved"].includes(result.status))
        ) {
          (await image(),
            say(
              result.status === "approved"
                ? "Your design is approved and ready to add to the bag."
                : "Your preview is ready. Take a look, then choose \u201CUse this design\u201D.",
            ));
          return;
        }
        if (["rejected", "failed"].includes(result.status)) {
          (say(
            result.error ||
              "We could not make a suitable preview. Please choose a different photo.",
            !0,
          ),
            (state = {}),
            clearStorage());
          return;
        }
        (say(
          result.status === "queued"
            ? "Your photo is in the queue. This usually takes a few minutes."
            : "We\u2019re drawing your face into the artwork. You can keep this page open while we work.",
        ),
          await new Promise((resolve) => setTimeout(resolve, 4e3)));
      }
      throw new Error(
        "Your preview is taking longer than usual. Check again shortly; you will not need to upload again.",
      );
    } catch (error) {
      (say(
        error.message ||
          "The connection was interrupted. Check your existing preview again.",
        !0,
      ),
        (q("[data-check]").hidden = !state.id));
    } finally {
      ((polling = !1), (busy = !1), sync());
    }
  }
  (root.querySelectorAll('[name="design-choice"]').forEach((el) =>
    el.addEventListener("change", () => {
      ((state.custom = custom()), save(), sync());
    }),
  ),
    consent.addEventListener("change", sync),
    file.addEventListener("change", () => {
      (epoch++,
        (state = {}),
        clearStorage(),
        previewUrl.startsWith("blob:") && URL.revokeObjectURL(previewUrl),
        (previewUrl = ""),
        sourceUrl && URL.revokeObjectURL(sourceUrl));
      const selected = file.files[0];
      (selected &&
      (!["image/jpeg", "image/png", "image/webp"].includes(selected.type) ||
        selected.size > 8 * 1024 * 1024)
        ? ((file.value = ""),
          (q("[data-source-photo]").hidden = !0),
          say("Choose a JPG, PNG or WebP image smaller than 8 MB.", !0))
        : ((sourceUrl = selected ? URL.createObjectURL(selected) : ""),
          (q("[data-source-photo]").src = sourceUrl),
          (q("[data-source-photo]").hidden = !selected),
          say(
            selected
              ? "Your photo is selected. Confirm permission, then create your preview."
              : "",
          )),
        (q("[data-check]").hidden = !0),
        sync());
    }),
    generate.addEventListener("click", async () => {
      if (!(!designValid || !file.files.length || !consent.checked || busy)) {
        ((busy = !0),
          sync(),
          say(
            "Uploading your photo and checking that it contains one clear face\u2026",
          ));
        try {
          if (state.id) return ((busy = !1), poll());
          state.token ||
            ((state = {
              ...(await (
                await request("/storefront/sessions", { method: "POST" })
              ).json()),
              created: Date.now(),
            }),
            save());
          const data = new FormData();
          (data.append("photo", file.files[0]),
            data.append("consent", "true"),
            data.append("template_id", root.dataset.design));
          const result = await (
            await request("/storefront/jobs", { method: "POST", body: data })
          ).json();
          (Object.assign(state, verifyDesign(result)),
            save(),
            (busy = !1),
            await poll());
        } catch (error) {
          (say(
            error.message ||
              "The upload was interrupted. Try again with the same photo.",
            !0,
          ),
            (busy = !1),
            sync());
        }
      }
    }),
    q("[data-check]").addEventListener("click", poll),
    q("[data-change]").addEventListener("click", () => {
      (epoch++,
        (state = {}),
        clearStorage(),
        (previewUrl = ""),
        (file.value = ""),
        (consent.checked = !1),
        (q("[data-source-photo]").hidden = !0),
        say("Choose a new photo to create another preview."),
        sync());
    }),
    q("[data-approve]").addEventListener("click", async () => {
      q("[data-approve]").disabled = !0;
      try {
        (Object.assign(
          state,
          verifyDesign(
            await (
              await request(
                "/storefront/jobs/" +
                  state.id +
                  "/approve?template_id=" +
                  encodeURIComponent(design),
                { method: "POST" },
              )
            ).json(),
          ),
        ),
          save(),
          say("Your design is approved and ready to add to the bag."),
          sync());
      } catch (error) {
        say(error.message, !0);
      } finally {
        q("[data-approve]").disabled = !1;
      }
    }),
    q("[data-enlarge]").addEventListener("click", () =>
      q("[data-dialog]").showModal(),
    ),
    q("[data-close]").addEventListener("click", () =>
      q("[data-dialog]").close(),
    ),
    form.addEventListener("submit", (event) => {
      custom() &&
        !approved() &&
        (event.preventDefault(),
        say(
          "Create and approve your preview before adding this personalised gift to the bag.",
          !0,
        ),
        q("[data-status]").scrollIntoView({
          block: "center",
          behavior: "smooth",
        }));
    }));
  try {
    const saved = JSON.parse(sessionStorage.getItem(key) || "{}");
    designValid &&
      saved.template_id === design &&
      saved.token &&
      saved.id &&
      Date.now() - saved.created < 864e5 &&
      ((state = saved),
      (q('[value="custom"]').checked = saved.custom !== !1),
      poll());
  } catch {}
  (customVariant &&
    variantSelect.value === customVariant.value &&
    (q('[value="custom"]').checked = !0),
    sync());
  if (!designValid)
    say(
      "Personalisation is unavailable for this design. Please choose the original artwork.",
      true,
    );
})();
//# sourceMappingURL=/cdn/shop/t/8/assets/personaliser.js.map?v=159391604080304364911792207795
